import { Avatar, AvatarGroup, Tooltip } from "@mui/material";
import type { FC } from "react";
import { useRoundaboutContext } from "./roundabout-context";

// Stolen from MUI's AvatarGroup example
// https://mui.com/components/avatars/#avatar-group
function stringToColor(string: string): string {
  let hash = 0;
  let i;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
}

const getLastSeenAgo = (lastSeenAt: string): string => {
  const lastSeen = new Date(lastSeenAt);
  const now = new Date();
  const diff = now.getTime() - lastSeen.getTime();
  const seconds = Math.floor(Math.max(diff, 0) / 1000);
  const minutes = Math.floor(seconds / 60);
  if (minutes > 0) {
    return `${minutes} minute${minutes === 1 ? "" : "s"} ago`;
  }
  if (seconds < 10) {
    return "just now";
  }

  return `${seconds} second${seconds === 1 ? "" : "s"} ago`;
};

const makeMessage = (nickname: string, role: string | null, lastSeenAt: string): string => {
  return `${nickname}${role ? ` is ${role}` : ""}, last updated ${getLastSeenAgo(lastSeenAt)}`;
};
export const FooterBlobs: FC = () => {
  const { currentOtherUsers } = useRoundaboutContext();
  return (
    <AvatarGroup max={8} data-testid="footer-blobs">
      {currentOtherUsers.map(({ nickname, role, sessionLastSeenAt, blobLetter, presence_ref }) => (
        <Tooltip title={makeMessage(nickname, role, sessionLastSeenAt)} key={presence_ref}>
          <Avatar
            sx={({ palette }) => ({
              bgcolor: stringToColor(nickname),
              // If they are editing show a warning
              borderColor: role === "Editing" ? palette.warning.main + " !important" : undefined,
            })}
          >
            {blobLetter}
          </Avatar>
        </Tooltip>
      ))}
    </AvatarGroup>
  );
};
